class MTBlog {
  constructor() {
    this.init();
  }

  init() {
    this.setupMobileTopicsToggle();
    this.setupBlogTabs();
    this.setupSearch();
    this.setupScrollToTop();
    this.setupResponsivePagination();
    
    // Initial setup for active tab
    this.setupInitialActiveTab();
  }

  setupInitialActiveTab() {
    // 等待DOM完全渲染后再执行
    setTimeout(() => {
      // 首先确保所有非活跃标签都隐藏
      const allTabContents = document.querySelectorAll('.mt-blog-tab-content[data-blog-content]');
      allTabContents.forEach(tabContent => {
        if (!tabContent.classList.contains('active')) {
          tabContent.style.display = 'none';
        } else {
          tabContent.style.display = 'grid'; // 或者 'block'，取决于你的CSS
        }
      });
      
      const activeTabContent = document.querySelector('.mt-blog-tab-content.active[data-blog-content]');
      if (activeTabContent) {
        // 先清除所有现有的自定义分页
        const existingCustomPaginations = activeTabContent.querySelectorAll('.mt-blog-pagination-custom');
        existingCustomPaginations.forEach(pagination => pagination.remove());
        
        const isMobile = window.innerWidth < 750;
        const postsPerPageMobile = parseInt(activeTabContent.getAttribute('data-posts-per-page-mobile')) || 6;
        const postsPerPageDesktop = parseInt(activeTabContent.getAttribute('data-posts-per-page-desktop')) || 9;
        
        const cards = activeTabContent.querySelectorAll('.mt-blog-card');
        const defaultPagination = activeTabContent.querySelector('.mt-blog-pagination:not(.mt-blog-pagination-custom)');
        
        console.log('Initial setup:', {
          isMobile,
          postsPerPageMobile,
          postsPerPageDesktop,
          cardsFound: cards.length 
        });
        
        if (isMobile) {
          // 移动端：隐藏默认分页，显示自定义分页
          if (defaultPagination) {
            defaultPagination.style.display = 'none';
          }
          
          // 显示移动端对应数量的文章
          cards.forEach((card, index) => {
            card.style.display = index < postsPerPageMobile ? 'block' : 'none';
          });
          
          console.log(`Mobile: showing ${Math.min(postsPerPageMobile, cards.length)} of ${cards.length} articles`);
          
          // 如果文章数量超过移动端每页数量，创建自定义分页
          if (cards.length > postsPerPageMobile) {
            this.createPagination(activeTabContent, cards.length, postsPerPageMobile);
          }
        } else {
          // 桌面端：显示桌面端设置的文章数量
          cards.forEach((card, index) => {
            card.style.display = index < postsPerPageDesktop ? 'block' : 'none';
          });
          
          console.log(`Desktop: showing ${Math.min(postsPerPageDesktop, cards.length)} of ${cards.length} articles`);
          
          // 隐藏默认分页，使用自定义分页
          if (defaultPagination) {
            defaultPagination.style.display = 'none';
          }
          
          // 如果文章数量超过桌面端每页数量，创建自定义分页
          if (cards.length > postsPerPageDesktop) {
            this.createPagination(activeTabContent, cards.length, postsPerPageDesktop);
          }
        }
      } else {
        console.log('No active tab content found!');
      }
    }, 100);
  }

  setupResponsivePagination() {
    const tabContents = document.querySelectorAll('.mt-blog-tab-content[data-blog-content]');
    
    const updatePagination = () => {
      const isMobile = window.innerWidth < 750;
      
      tabContents.forEach(tabContent => {
        // Skip if this tab is not active
        if (!tabContent.classList.contains('active')) {
          return;
        }
        
        const postsPerPageDesktop = parseInt(tabContent.getAttribute('data-posts-per-page-desktop')) || 9;
        const postsPerPageMobile = parseInt(tabContent.getAttribute('data-posts-per-page-mobile')) || 6;
        
        const cards = tabContent.querySelectorAll('.mt-blog-card');
        let existingDefaultPagination = tabContent.querySelector('.mt-blog-pagination:not(.mt-blog-pagination-custom)');
        
        // Get current page before clearing pagination
        const currentPage = parseInt(tabContent.getAttribute('data-current-page')) || 1;
        
        console.log(`[Resize] Current page before update: ${currentPage}, isMobile: ${isMobile}`);
        
        // 清除所有现有的自定义分页
        const existingCustomPaginations = tabContent.querySelectorAll('.mt-blog-pagination-custom');
        existingCustomPaginations.forEach(pagination => pagination.remove());
        
        if (cards.length === 0) return;
        
        const postsPerPage = isMobile ? postsPerPageMobile : postsPerPageDesktop;
        const totalPages = Math.ceil(cards.length / postsPerPage);
        
        // Ensure current page is valid for the new posts per page setting
        const validCurrentPage = Math.min(currentPage, totalPages);
        
        console.log(`[Resize] Valid current page: ${validCurrentPage}, totalPages: ${totalPages}`);
        
        // Calculate start and end indices for current page
        const start = (validCurrentPage - 1) * postsPerPage;
        const end = start + postsPerPage;
        
        if (isMobile) {
          // Mobile logic
          if (existingDefaultPagination) {
            existingDefaultPagination.style.display = 'none';
          }
          
          // Show current page of articles for mobile
          cards.forEach((card, index) => {
            card.style.display = (index >= start && index < end) ? 'block' : 'none';
          });
          
          // Create custom pagination if needed
          if (cards.length > postsPerPageMobile) {
            this.createPagination(tabContent, cards.length, postsPerPageMobile, validCurrentPage);
          }
        } else {
          // Desktop logic - show current page of articles
          if (existingDefaultPagination) {
            existingDefaultPagination.style.display = 'none';
          }
          
          // Show current page articles for desktop
          cards.forEach((card, index) => {
            card.style.display = (index >= start && index < end) ? 'block' : 'none';
          });
          
          // Create pagination if needed
          if (cards.length > postsPerPageDesktop) {
            this.createPagination(tabContent, cards.length, postsPerPageDesktop, validCurrentPage);
          }
        }
      });
    };
    
    // Initial setup
    updatePagination();
    
    // Update on resize with debounce
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(updatePagination, 300);
    });
  }

  createPagination(tabContent, totalCards, postsPerPage, initialPage = 1) {
    const totalPages = Math.ceil(totalCards / postsPerPage);
    if (totalPages <= 1) return;
    
    // 先移除已存在的自定义分页
    const existingCustomPagination = tabContent.querySelector('.mt-blog-pagination-custom');
    if (existingCustomPagination) {
      existingCustomPagination.remove();
    }
    
    // Use the provided initial page or default to 1
    let currentPage = Math.min(Math.max(1, initialPage), totalPages);
    
    const generatePaginationHTML = (current) => {
      let paginationHTML = '<div class="mt-blog-pagination mt-blog-pagination-custom">';
      
      // Previous arrow
      paginationHTML += `
        <button class="mt-blog-pagination-arrow mt-blog-pagination-prev prev" ${current === 1 ? 'disabled' : ''}></button>
      `;
      
      // Page numbers logic
      const maxVisible = 5; // Maximum visible page numbers
      let startPage = Math.max(1, current - Math.floor(maxVisible / 2));
      let endPage = Math.min(totalPages, startPage + maxVisible - 1);
      
      // Adjust start if we're near the end
      if (endPage - startPage < maxVisible - 1) {
        startPage = Math.max(1, endPage - maxVisible + 1);
      }
      
      // First page
      if (startPage > 1) {
        paginationHTML += `<button class="mt-blog-pagination-number" data-page="1">1</button>`;
        if (startPage > 2) {
          paginationHTML += `<span class="mt-blog-pagination-dots">...</span>`;
        }
      }
      
      // Middle pages
      for (let i = startPage; i <= endPage; i++) {
        const isActive = i === current ? 'active' : '';
        paginationHTML += `<button class="mt-blog-pagination-number ${isActive}" data-page="${i}">${i}</button>`;
      }
      
      // Last page
      if (endPage < totalPages) {
        if (endPage < totalPages - 1) {
          paginationHTML += `<span class="mt-blog-pagination-dots">...</span>`;
        }
        paginationHTML += `<button class="mt-blog-pagination-number" data-page="${totalPages}">${totalPages}</button>`;
      }
      
      // Next arrow
      paginationHTML += `
        <button class="mt-blog-pagination-arrow mt-blog-pagination-next next" ${current === totalPages ? 'disabled' : ''}></button>
      `;
      
      paginationHTML += '</div>';
      return paginationHTML;
    };
    
    const updatePagination = (page = 1, shouldScroll = false) => {
      currentPage = page;
      
      console.log(`[Pagination Update] Switching to page ${currentPage}`);
      
      // IMPORTANT: Save current page immediately to data attribute
      // This ensures resize events will preserve the current page
      tabContent.setAttribute('data-current-page', currentPage.toString());
      
      // Remove existing pagination
      const existing = tabContent.querySelector('.mt-blog-pagination-custom');
      if (existing) existing.remove();
      
      // Add new pagination
      tabContent.insertAdjacentHTML('beforeend', generatePaginationHTML(currentPage));
      
      // Show correct page of articles
      const cards = tabContent.querySelectorAll('.mt-blog-card');
      const start = (currentPage - 1) * postsPerPage;
      const end = start + postsPerPage;
      
      cards.forEach((card, index) => {
        card.style.display = (index >= start && index < end) ? 'block' : 'none';
      });
      
      // Add event listeners
      const customPagination = tabContent.querySelector('.mt-blog-pagination-custom');
      const prevBtn = customPagination.querySelector('.mt-blog-pagination-prev');
      const nextBtn = customPagination.querySelector('.mt-blog-pagination-next');
      const pageNumbers = customPagination.querySelectorAll('.mt-blog-pagination-number');
      
      prevBtn.addEventListener('click', () => {
        if (currentPage > 1) updatePagination(currentPage - 1, true);
      });
      
      nextBtn.addEventListener('click', () => {
        if (currentPage < totalPages) updatePagination(currentPage + 1, true);
      });
      
      pageNumbers.forEach(btn => {
        btn.addEventListener('click', () => {
          const page = parseInt(btn.getAttribute('data-page'));
          updatePagination(page, true);
        });
      });
      
      // Scroll to component top only when user clicks pagination
      if (shouldScroll) {
        const blogSection = document.querySelector('.mt-blog-section');
        if (blogSection) {
          setTimeout(() => {
            blogSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 100);
        }
      }
    };
    
    // Initial render with the specified page (no scroll)
    updatePagination(currentPage, false);
    
    // Store pagination data
    tabContent.setAttribute('data-current-page', currentPage.toString());
    tabContent.setAttribute('data-total-pages', totalPages.toString());
  }

  updatePaginationDisplay(tabContent, totalCards, postsPerPage) {
    const isMobile = window.innerWidth < 750;
    const cards = tabContent.querySelectorAll('.mt-blog-card');
    const customPagination = tabContent.querySelector('.mt-blog-pagination-custom');
    const defaultPagination = tabContent.querySelector('.mt-blog-pagination:not(.mt-blog-pagination-custom)');
    
    // Show appropriate cards based on current screen size
    const currentPage = parseInt(tabContent.getAttribute('data-current-page')) || 1;
    const start = (currentPage - 1) * postsPerPage;
    const end = start + postsPerPage;
    
    cards.forEach((card, index) => {
      card.style.display = (index >= start && index < end) ? 'block' : 'none';
    });
    
    // Show/hide pagination based on screen size
    if (customPagination) {
      customPagination.style.display = isMobile ? 'flex' : 'none';
    }
    if (defaultPagination) {
      defaultPagination.style.display = isMobile ? 'none' : 'flex';
    }
    
    // Update custom pagination if it exists
    if (customPagination && isMobile) {
      const totalPages = Math.ceil(totalCards / postsPerPage);
      const currentPageEl = customPagination.querySelector('.mt-blog-pagination-current');
      const totalPagesInfo = customPagination.querySelector('.mt-blog-pagination-info');
      
      if (currentPageEl && totalPagesInfo) {
        totalPagesInfo.innerHTML = `<span class="mt-blog-pagination-current">${currentPage}</span> / ${totalPages}`;
        
        const prevBtn = customPagination.querySelector('.mt-blog-pagination-prev');
        const nextBtn = customPagination.querySelector('.mt-blog-pagination-next');
        
        if (prevBtn) {
          prevBtn.disabled = currentPage === 1;
          if (prevBtn.disabled) {
            prevBtn.classList.add('disabled');
          } else {
            prevBtn.classList.remove('disabled');
          }
        }
        
        if (nextBtn) {
          nextBtn.disabled = currentPage === totalPages;
          if (nextBtn.disabled) {
            nextBtn.classList.add('disabled');
          } else {
            nextBtn.classList.remove('disabled');
          }
        }
      }
    }
  }

  setupSearch() {
    const searchInput = document.getElementById('mt-blog-search-input');
    const searchBtn = document.getElementById('mt-blog-search-btn');
    const clearBtn = document.getElementById('mt-blog-search-clear');
    const searchDropdown = document.getElementById('mt-blog-search-dropdown');
    const searchResultsContainer = document.getElementById('mt-blog-search-results-container');
    const noResults = document.getElementById('mt-blog-no-results');
    const tabContents = document.querySelectorAll('.mt-blog-tab-content[data-blog-content]');
    const topicBtns = document.querySelectorAll('.mt-blog-topic-btn[data-blog-tab]');

    if (!searchInput || !searchResultsContainer || !searchDropdown) return;

    let searchTimeout;
    let currentFilteredArticles = [];

    const clearSearch = () => {
      searchInput.value = '';
      currentFilteredArticles = [];
      if (clearBtn) clearBtn.style.display = 'none';
      if (searchDropdown) searchDropdown.classList.remove('active');
      searchResultsContainer.classList.remove('active');
      searchResultsContainer.style.display = 'none';
      searchResultsContainer.innerHTML = '<div class="mt-blog-no-results" id="mt-blog-no-results" style="display: none;"><p>No articles found matching your search.</p></div>';
      
      // Show first tab content
      tabContents.forEach((content, index) => {
        if (index === 0) {
          content.classList.add('active');
          content.style.display = 'grid';
        } else {
          content.classList.remove('active');
          content.style.display = 'none';
        }
      });

      // Reset topic buttons
      topicBtns.forEach((btn, index) => {
        if (index === 0) {
          btn.classList.add('active');
        } else {
          btn.classList.remove('active');
        }
      });
    };

    const updateDropdown = () => {
      const query = searchInput.value.trim().toLowerCase();
      
      if (query.length === 0) {
        searchDropdown.classList.remove('active');
        if (clearBtn) clearBtn.style.display = 'none';
        return;
      }

      // Show clear button
      if (clearBtn) clearBtn.style.display = 'flex';

      const articles = window.mtBlogData?.articles || [];
      currentFilteredArticles = articles.filter(article => {
        const titleMatch = article.title.toLowerCase().includes(query);
        const categoryMatch = article.category.toLowerCase().includes(query);
        return titleMatch || categoryMatch;
      });

      if (currentFilteredArticles.length === 0) {
        searchDropdown.innerHTML = '<div class="mt-blog-search-dropdown-no-results">No articles found</div>';
        searchDropdown.classList.add('active');
        return;
      }

      // Show all results in dropdown with scrollbar
      const html = currentFilteredArticles.map(article => `
        <div class="mt-blog-search-dropdown-item" data-url="${article.url}">
          <div class="mt-blog-search-dropdown-category">${article.category}</div>
          <h4 class="mt-blog-search-dropdown-title">${article.title}</h4>
        </div>
      `).join('');

      searchDropdown.innerHTML = html;
      searchDropdown.classList.add('active');

      // Add click handlers to dropdown items
      searchDropdown.querySelectorAll('.mt-blog-search-dropdown-item').forEach(item => {
        item.addEventListener('click', () => {
          const url = item.getAttribute('data-url');
          if (url) {
            window.location.href = url;
          }
        });
      });
    };

    const performSearch = () => {
      const query = searchInput.value.trim().toLowerCase();
      
      if (query.length === 0) {
        clearSearch();
        return;
      }

      // Filter articles based on search query
      const articles = window.mtBlogData?.articles || [];
      currentFilteredArticles = articles.filter(article => {
        const titleMatch = article.title.toLowerCase().includes(query);
        const categoryMatch = article.category.toLowerCase().includes(query);
        const excerptMatch = article.excerpt && article.excerpt.toLowerCase().includes(query);
        return titleMatch || categoryMatch || excerptMatch;
      });

      // Close dropdown
      searchDropdown.classList.remove('active');

      // Hide all tab contents
      tabContents.forEach(content => {
        content.classList.remove('active');
        content.style.display = 'none';
      });
      
      // Remove active from all topic buttons
      topicBtns.forEach(btn => btn.classList.remove('active'));

      // Show search results container
      searchResultsContainer.classList.add('active');
      searchResultsContainer.style.display = 'grid';

      if (currentFilteredArticles.length === 0) {
        const noResultsEl = searchResultsContainer.querySelector('.mt-blog-no-results');
        if (noResultsEl) {
          noResultsEl.style.display = 'block';
        }
        searchResultsContainer.innerHTML = '<div class="mt-blog-no-results" style="display: block;"><p>No articles found matching your search.</p></div>';
        return;
      }

      // Generate search results HTML in grid
      const html = currentFilteredArticles.map(article => `
        <article class="mt-blog-card">
          <a href="${article.url}" class="mt-blog-card-link">
            ${article.image ? `
              <div class="mt-blog-card-image">
                <img 
                  src="${article.image}"
                  alt="${article.title}"
                  loading="lazy"
                >
              </div>
            ` : ''}
            <div class="mt-blog-card-content">
              <p class="mt-blog-card-category">${article.category}</p>
              <h3 class="mt-blog-card-title">${article.title}</h3>
              ${article.excerpt ? `
                <div class="mt-blog-card-excerpt">${article.excerpt}</div>
              ` : ''}
            </div>
          </a>
        </article>
      `).join('');

      searchResultsContainer.innerHTML = html;
    };

    // Update dropdown on input with debounce
    searchInput.addEventListener('input', () => {
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(updateDropdown, 300);
    });

    // Perform search on button click
    if (searchBtn) {
      searchBtn.addEventListener('click', performSearch);
    }

    // Clear search
    if (clearBtn) {
      clearBtn.addEventListener('click', clearSearch);
    }

    // Perform search on Enter key
    searchInput.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        performSearch();
      }
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.mt-blog-search')) {
        searchDropdown.classList.remove('active');
      }
    });
  }

  setupBlogTabs() {
    const tabButtons = document.querySelectorAll('.mt-blog-topic-btn[data-blog-tab]');
    const tabContents = document.querySelectorAll('.mt-blog-tab-content[data-blog-content]');
    const searchInput = document.getElementById('mt-blog-search-input');
    const clearBtn = document.getElementById('mt-blog-search-clear');
    const searchDropdown = document.getElementById('mt-blog-search-dropdown');
    const searchResultsContainer = document.getElementById('mt-blog-search-results-container');

    if (tabButtons.length === 0 || tabContents.length === 0) return;

    tabButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const blogHandle = button.getAttribute('data-blog-tab');

        // Clear search when switching tabs
        if (searchInput) {
          searchInput.value = '';
          if (clearBtn) clearBtn.style.display = 'none';
          if (searchDropdown) searchDropdown.classList.remove('active');
          if (searchResultsContainer) {
            searchResultsContainer.classList.remove('active');
            searchResultsContainer.style.display = 'none';
          }
        }

        // Remove active class from all buttons and contents
        tabButtons.forEach(btn => btn.classList.remove('active'));
        tabContents.forEach(content => {
          content.classList.remove('active');
          content.style.display = 'none'; // 隐藏所有标签页内容
        });

        // Add active class to clicked button and corresponding content
        button.classList.add('active');
        const targetContent = document.querySelector(`.mt-blog-tab-content[data-blog-content="${blogHandle}"]`);
        if (targetContent) {
          targetContent.classList.add('active');
          targetContent.style.display = 'grid'; // 显示选中的标签页内容
          
          // Reset pagination for the new tab
          targetContent.setAttribute('data-current-page', '1');
          
          // 清除所有现有的自定义分页
          const existingCustomPaginations = targetContent.querySelectorAll('.mt-blog-pagination-custom');
          existingCustomPaginations.forEach(pagination => pagination.remove());
          
          // Determine pagination based on screen size
          const isMobile = window.innerWidth < 750;
          const postsPerPageDesktop = parseInt(targetContent.getAttribute('data-posts-per-page-desktop')) || 9;
          const postsPerPageMobile = parseInt(targetContent.getAttribute('data-posts-per-page-mobile')) || 6;
          
          const cards = targetContent.querySelectorAll('.mt-blog-card');
          
          if (isMobile) {
            // Mobile: show mobile page size and create custom pagination if needed
            cards.forEach((card, index) => {
              card.style.display = index < postsPerPageMobile ? 'block' : 'none';
            });
            
            if (cards.length > postsPerPageMobile) {
              this.createPagination(targetContent, cards.length, postsPerPageMobile);
            }
            
            // Hide default pagination
            const defaultPagination = targetContent.querySelector('.mt-blog-pagination:not(.mt-blog-pagination-custom)');
            if (defaultPagination) {
              defaultPagination.style.display = 'none';
            }
          } else {
            // Desktop: show desktop page size and create custom pagination if needed
            cards.forEach((card, index) => {
              card.style.display = index < postsPerPageDesktop ? 'block' : 'none';
            });
            
            const defaultPagination = targetContent.querySelector('.mt-blog-pagination:not(.mt-blog-pagination-custom)');
            if (defaultPagination) {
              defaultPagination.style.display = 'none';
            }
            
            if (cards.length > postsPerPageDesktop) {
              this.createPagination(targetContent, cards.length, postsPerPageDesktop);
            }
          }
        }

        // Close mobile dropdown after selection
        const topicsHeader = document.querySelector('.mt-blog-topics-header');
        const topicsList = document.querySelector('.mt-blog-topics-list');
        if (topicsHeader && topicsList) {
          topicsHeader.setAttribute('aria-expanded', 'false');
          topicsList.classList.remove('active');
        }

        // Scroll to blog grid on mobile - DISABLED to prevent auto-scrolling
        // if (window.innerWidth < 750) {
        //   const blogGrid = document.querySelector('.mt-blog-grid');
        //   if (blogGrid) {
        //     setTimeout(() => {
        //       blogGrid.scrollIntoView({ behavior: 'smooth', block: 'start' });
        //     }, 100);
        //   }
        // }
      });
    });
  }

  setupMobileTopicsToggle() {
    const topicsHeader = document.querySelector('.mt-blog-topics-header');
    const topicsList = document.querySelector('.mt-blog-topics-list');
    const toggle = document.querySelector('.mt-blog-topics-toggle');

    if (!topicsHeader || !topicsList) return;

    topicsHeader.addEventListener('click', () => {
      const isExpanded = topicsHeader.getAttribute('aria-expanded') === 'true';
      
      topicsHeader.setAttribute('aria-expanded', !isExpanded);
      topicsList.classList.toggle('active');
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.mt-blog-topics')) {
        topicsHeader.setAttribute('aria-expanded', 'false');
        topicsList.classList.remove('active');
      }
    });
  }

  setupScrollToTop() {
    // Smooth scroll to top when changing pages - DISABLED to prevent auto-scrolling
    // const paginationLinks = document.querySelectorAll('.mt-blog-pagination a');
    
    // paginationLinks.forEach(link => {
    //   link.addEventListener('click', () => {
    //     const blogSection = document.querySelector('.mt-blog-section');
    //     if (blogSection) {
    //       setTimeout(() => {
    //         blogSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    //       }, 100);
    //     }
    //   });
    // });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new MTBlog();
  });
} else {
  new MTBlog();
}
